import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
    const { isAuthenticated, isLoading, error, loginWithRedirect, logout } = useAuth0();
    const location = useLocation();

    if (isLoading) return <div>Loading...</div>;

    if (error) {
        console.error("Authentication error:", error);
        return (
            <div style={{ padding: "2rem", color: "red" }}>
                <h2>{error.error === "access_denied" ? "Access Denied" : "Authentication Error"}</h2>
                <p>{error.message}</p>
                <button
                    onClick={() =>
                        logout({ returnTo: window.location.origin })
                    }
                    style={{
                        padding: "10px 20px",
                        marginTop: "1rem",
                        backgroundColor: "#dc2626",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                    }}
                >
                    Try with another account
                </button>
            </div>
        );
    }

    if (!isAuthenticated) {
        loginWithRedirect({
            appState: { returnTo: location.pathname },
        });
        return null;
    }

    return children;
};